import { createContext } from 'react';

export interface TableOptions {
	showSortPriority: boolean;
	sortTooltip?: string;
}

export const DEFAULT_TABLE_OPTIONS: TableOptions = { showSortPriority: false };

const TableOptionsContext = createContext<TableOptions>(DEFAULT_TABLE_OPTIONS);

export default TableOptionsContext;
